import { useEffect, useState } from "react";
import useLeagueBySlug from "@/hooks/useLeagueBySlug";
import { useCompConfig } from "@/context/CompConfigContext";
import { buildThemeConfig } from "@/components/LichThiDauFull/buildThemeConfig";
import { KbvPluginService } from "@/services/kbvPluginService";

async function fetchLeagueStandings(leagueId) {
  if (!leagueId) return null;
  try {
    const data = await KbvPluginService.getLeagueStandings(leagueId);
    if (!data || Array.isArray(data)) return null;
    const result = data.result;
    if (!result) return null;
    return { ...result, colorInfos: data.colorInfos || [] };
  } catch (error) {
    console.error(error);
    return null;
  }
}

export default function useBangXepHangByLeague(leagueSlug) {
  const compConfig = useCompConfig();
  const themeStyle = buildThemeConfig(compConfig, compConfig.hasDataConfig);
  const [activeSlug, setActiveSlug] = useState(leagueSlug || "");
  const { league, loading: leagueLoading } = useLeagueBySlug(activeSlug);
  const leagueId = league?.id;
  const [standingsRes, setStandingsRes] = useState(null);
  const [standingsLoading, setStandingsLoading] = useState(!!activeSlug);

  useEffect(() => {
    setActiveSlug(leagueSlug || "");
  }, [leagueSlug]);

  useEffect(() => {
    if (!leagueId) {
      setStandingsRes(null);
      setStandingsLoading(false);
      return undefined;
    }
    let cancelled = false;
    setStandingsRes(null);
    setStandingsLoading(true);
    (async () => {
      const res = await fetchLeagueStandings(leagueId);
      if (cancelled) return;
      setStandingsRes(res);
      setStandingsLoading(false);
    })();
    return () => {
      cancelled = true;
    };
  }, [leagueId]);

  const waiting = !!activeSlug && (leagueLoading || standingsLoading);
  const failed = !!activeSlug && !leagueLoading && !league;

  return {
    themeStyle,
    activeSlug,
    setActiveSlug,
    league,
    standingsRes,
    waiting,
    failed,
  };
}
